<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="sliderValues"
                display-unit="s"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations } from 'vuex';
import baseOption from '@/options/mixins/base-option';
import { SET_CAROUSEL_SPEED } from '@/store/types/mutation-types';

export default {
    name: 'carousel-speed',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Carousel Speed',
            sliderIndex: 3,
            sliderValues: ['None', '1', '2', '4', '5', '10', '15'], // numbers corresponds to seconds; 'None' = no auto slide transitions
        };
    },

    methods: {
        ...mapMutations({
            setCarouselSpeed: SET_CAROUSEL_SPEED,
        }),

        onInput(newSliderIndex) {
            const speedValue = this.sliderValues[newSliderIndex];

            this.sliderIndex = newSliderIndex;
            this.setCarouselSpeed({ speed: speedValue, el: this.selectedElements[0] });
            this.onOptionChange(speedValue);
        },

        onSelectedElement() {
            // read from component and set slider index:
            const speed = this.selectedElements[0].getElementData('carousel-speed');

            // if speed is undefined, default to a middling value:
            const sliderIndex = this.sliderValues.indexOf(speed);

            this.sliderIndex = sliderIndex >= 0 ? sliderIndex : 3;
        },
    },
};
</script>
